import { render } from "./Promo-steps.vue?vue&type=template&id=3ba0ee64&scoped=true"
import script from "./Promo-steps.vue?vue&type=script&lang=js"
export * from "./Promo-steps.vue?vue&type=script&lang=js"

import "./Promo-steps.vue?vue&type=style&index=0&id=3ba0ee64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba0ee64"]])

export default __exports__